import AnalysysChartsTheme from '@engine/features/analysis_stats/chart/analysis_stats_by_theme.js';
import Configs from '@engine/features/dashboard/top_5/dashboard_top5_configs';
import FetchDataset from '@engine/features/dashboard/chart/dashboard_chart_fetch';
import Top5 from '@engine/features/dashboard/top_5/dashboard_top5_line';
import { exists } from '@engine/lib/utility/exists';

function CustomChart() {
  var customChartBtns = ['.load_highcharts', '.load_delta_graph'];
  var container_selector = '.analysis-custom-chart-container';
  var date_from = '#from';
  var date_to = '#to';
  var chartNotCreated = true;

  function configFor(action) {
    return action === 'delta_graph_for' ? Configs.forDelta() : Configs.forVolume();
  }

  function fetchDataset(entity_type, entity_id, action) {
    var data = {
      entity: entity_type,
      id: entity_id,
      date_from: $(date_from).val(),
      date_to: $(date_to).val()
    };
    FetchDataset.fetch('/analysis/' + action, data, function (response) {
      Top5.forceUpdate(response, AnalysysChartsTheme.styles, configFor(action));
    }, $(container_selector));
  }

  function updateChart($this) {
    var entity_type = $this.data('entity');
    var entity_id = $('#analysis_' + entity_type + '_id').val();
    var action = $this.data('action');
    fetchDataset(entity_type, entity_id, action);
    Top5.updateDateRange(date_from, date_to);
  }

  function showChart() {
    if (chartNotCreated) {
      Top5.create($('#analysis-custom-chart'), AnalysysChartsTheme.styles);
      chartNotCreated = false;
    }

    $(container_selector).fadeIn();
  }

  function initialize() {
    if (!exists($(customChartBtns[0]))) {
      return;
    }

    $(customChartBtns.join(', ')).on('click', function () {
      showChart();
      updateChart($(this));
    });
  }

  return {
    initialize: initialize
  };
}

export default CustomChart();